'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  feature: string;
  plus: boolean | string;
  prime: boolean | string;
  pro: boolean | string;
}

const comparisonData: ComparisonFeature[] = [
  {
    feature: 'Parking SMS notification',
    plus: true,
    prime: true,
    pro: true,
  },
  {
    feature: 'Private contact protection',
    plus: true,
    prime: true,
    pro: true,
  },
  {
    feature: 'Up to 15 alerts per plan',
    plus: true,
    prime: true,
    pro: true,
  },
  {
    feature: 'Call details to vehicle owner',
    plus: false,
    prime: true,
    pro: true,
  },
  {
    feature: 'Dedicated support',
    plus: false,
    prime: false,
    pro: true,
  },
  {
    feature: 'Validity options',
    plus: '6M and 12M',
    prime: '6M and 12M',
    pro: 'Custom',
  },
  {
    feature: 'Best for',
    plus: 'Individual owners',
    prime: 'Frequent city users',
    pro: 'Society and enterprise',
  },
];

export default function ComparisonTable() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const renderCell = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Icon name="CheckIcon" variant="solid" size={20} className="text-[#42AF47] mx-auto" />
      ) : (
        <Icon name="XMarkIcon" variant="solid" size={20} className="text-gray-400 mx-auto" />
      );
    }
    return <span className="text-sm font-medium text-gray-800">{value}</span>;
  };

  if (!isHydrated) {
    return null;
  }

  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
      <div className="bg-gradient-to-r from-[#42AF47] to-[#2e8b3f] p-6 md:p-8">
        <h3 className="text-2xl md:text-3xl font-heading font-bold text-white text-center">Plan Comparison</h3>
        <p className="text-base text-white/90 text-center mt-3">Compare Plus, Prime, and Pro at a glance</p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[720px]">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              <th className="px-6 py-5 text-left text-sm md:text-base font-heading font-semibold text-gray-900">Features</th>
              <th className="px-6 py-5 text-center text-sm md:text-base font-heading font-semibold text-gray-900">Plus</th>
              <th className="px-6 py-5 text-center text-sm md:text-base font-heading font-semibold text-gray-900">Prime</th>
              <th className="px-6 py-5 text-center text-sm md:text-base font-heading font-semibold text-gray-900">Pro</th>
            </tr>
          </thead>
          <tbody>
            {comparisonData.map((row, index) => (
              <tr
                key={index}
                className={`border-b border-gray-100 ${
                  index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                } hover:bg-gray-50 transition-colors duration-200`}
              >
                <td className="px-6 py-5 text-sm md:text-base font-medium text-gray-900">{row.feature}</td>
                <td className="px-6 py-5 text-center">{renderCell(row.plus)}</td>
                <td className="px-6 py-5 text-center">{renderCell(row.prime)}</td>
                <td className="px-6 py-5 text-center">{renderCell(row.pro)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
